import 'rsuite/dist/rsuite.min.css';
import './app.scss';
import DetailPage from './components/DetailPage/DetailPage.js';
import Navbar from './components/landing/header/Navbar.js';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Privatepoll from './components/Privatepoll/Privatepoll.js';
import Mycreatedpolls from './components/Mycreatedpolls/Mycreatedpolls.js';
import Createpool from './components/Createprivatepoll/Createpool.js';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import MyPrediction from './components/Mycreatedpolls/MyPrediction.js';
import PointsBreakdown from './components/Mycreatedpolls/PointsBreakdown.js';
import Blog from './components/Blog/Blog.js';
import BlogDetail from './components/Blog/BlogDetail.js';
import Homepage from './components/Homepage/Homepage.js';
import { useState } from 'react';
import GetRain from './components/GetRain/GetRain.js';
import Termsofuse from './components/Termsofuse/Termsofuse.js';
import Privacy from './components/Termsofuse/Privacy.js';
import About from './components/AboutUs/About.js';
import BrandAssets from './components/BrandAssets/BrandAssets.js';
import UserProfile from './components/Mycreatedpolls/UserProfile.js';
import Liquidity from './components/Liquidity/Liquidity.js';
import Crash from './components/Crash/Crash.js';
import SEO from './components/SEO.js';
import { SHOW_CRASHGAME } from './utils/Enviroment.js';
import Faqs from './components/Homepage/Faqs/Faqs.js';

function App() {
  const [show6, setShow6] = useState(false);
  return (
    <>
      <SEO />
      <Router>
        <Navbar show6={show6} setShow6={setShow6} />
        <Routes>
          {/* <Route exact path='/explore-market' element={<Landing />} /> */}
          {/* <Route exact path='/' element={<Homepage show6={show6} setShow6={setShow6} />} /> */}
          {/* <Route exact path='/detail' element={<DetailPage />} /> */}
          {/* <Route exact path='/privatemarket' element={<Privatepoll />} /> */}
          <Route exact path='/myprofile' element={<Mycreatedpolls />} />
          {/* <Route exact path='/myprediction' element={<MyPrediction />} /> */}
          {/* <Route exact path='/points-breakdown' element={<PointsBreakdown />} /> */}
          {/* <Route exact path='/createpool' element={<Createpool />} /> */}
          {/* <Route exact path='/blog' element={<Blog />} /> */}
          {/* <Route exact path='/blog-detail' element={<BlogDetail />} /> */}
          {/* <Route exact path='/get-rain' element={<GetRain />} /> */}
          <Route exact path='/terms' element={<Termsofuse />} />
          <Route exact path='/privacy-policy' element={<Privacy />} />
          {/* <Route exact path='/about-us' element={<About />} /> */}
          {/* <Route exact path='/brand-assets' element={<BrandAssets />} /> */}
          {/* <Route exact path='/user-profile' element={<UserProfile />} /> */}
          {/* {
            SHOW_CRASHGAME ? (
              <Route exact path="/liquidity" element={<Liquidity />} />
            ) : (
              <Route path="/liquidity" element={<Navigate to="/" replace />} />
            )}
          {SHOW_CRASHGAME ? (
            <Route path="/risk" element={<Crash />} />
          ) : (
            <Route path="/risk" element={<Navigate to="/" replace />} />
          )} */}
          <Route path="/" element={<Crash />} />
          <Route exact path="/liquidity" element={<Liquidity />} />
          <Route exact path="/faqs" element={<Faqs />} />

        </Routes>
      </Router>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        style={{ fontSize: '16px', zIndex: "9999999999999999" }}
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;

//
